import React from "react";
//Limitless imports
import { useKnowledgeLibraryContext } from "../../hooks/knowledge/KnowledgeLibraryContext";
import Grid from "@limitless/modern/layout/Grid";
import VerticalTab from "@limitless/modern/navigation/vertical-tabs/VerticalTabs";
import Typography from "@limitless/modern/data-display/typography/Typography";
import KnowledgeSearchInput from "../../components-modern/knowledge-search-input/KnowledgeSearchInput";
const KnowledgeBaseLeftPanel = () => {
  const {
    selectedLibrary,
    libraryResults,
    selectCategory,
    selectSubCategory,
    loadCategoryArticles,
    clearSearchTerm
  } = useKnowledgeLibraryContext();
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const {
    categories,
    hasSearched
  } = libraryResults;
  React.useEffect(() => {
    if (hasSearched) {
      setSelectedTabIndex(false);
    } else if (!selectedTabIndex) {
      setSelectedTabIndex(0);
    }
  }, [hasSearched]);
  const categoryList = React.useMemo(() => {
    const categoryList = [];
    if (categories.length > 0) {
      categories.map(category => {
        categoryList.push({
          label: category.category,
          value: category.category,
          category: category.subcategory
        });
      });
    }
    categoryList.sort((a, b) => a.label.localeCompare(b.label));
    return [{
      label: "Top FAQ",
      value: "Top FAQ"
    }, ...categoryList];
  }, [categories]);
  const handleCategoryTabChange = (e, index) => {
    setSelectedTabIndex(index);
    if (hasSearched) {
      clearSearchTerm();
    }
    if (index !== 0) {
      const selectedCategory = categoryList.find((i, categoryIndex) => categoryIndex === index);
      selectCategory(selectedCategory);
    } else {
      loadCategoryArticles(selectedLibrary, selectedLibrary.knowledgeCategory);
    }
  };
  const handleSubCategoryChange = (subcategoryIndex, categoryIndex) => {
    const selectedCategory = categoryList.find((i, index) => categoryIndex === index);
    selectSubCategory(selectedCategory.label, selectedCategory.category[subcategoryIndex]);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    sx: {
      padding: "48px 34px 0px 48px"
    }
  }, /*#__PURE__*/React.createElement(KnowledgeSearchInput, {
    variant: "standard"
  })), /*#__PURE__*/React.createElement(VerticalTab, {
    items: categoryList,
    onChange: handleCategoryTabChange,
    value: selectedTabIndex,
    handleSubCategoryChange: handleSubCategoryChange
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "subtitle2",
    mb: 2,
    sx: {
      color: theme => theme.palette.grey[4]
    }
  }, "Categories")));
};
export default KnowledgeBaseLeftPanel;